<template>
    <form @submit.prevent="handleSubmit(item)">
        <div class="row"  v-if="item.correction">
            <div class="col-sm-12">
                <h4>Faktura korygująca do faktury {{item.correctedInvoice.fullNumber}}</h4>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-5">
                <h3>Nabywca</h3>
                <div :class="{ 'form-group': true, 'has-error': (errors && errors.customerData && errors.customerData.name) }">
                    <label for="_name" class="control-label">Nazwa</label>
                    <autocomplete id="_name"
                                  ref="name"
                                  :classes="{ wrapper: 'form-wrapper', input: 'form-control', list: 'data-list', item: 'data-list-item' }"
                                  :onShouldGetData="searchDebtorByName"
                                  :onShouldRenderChild="renderAutocompleteItem"
                                  :onSelect="autocompleteItemSelected"
                                  :debounce="500"
                                  :min="3"
                                  :onInput="setNameValue"
                                  url="test"
                                  anchor="name"

                    ></autocomplete>
                    <span v-if="errors && errors.customerData && errors.customerData.name" class="help-block"
                          id="_name_helpBlock">{{ errors.customerData.name }}</span>
                </div>
                <div class="row form-group">
                    <div :class="{ 'form-group col-lg-6': true, 'has-error': (errors && errors.customerData && errors.customerData.nip) }">
                        <label for="_nip" class="control-label">NIP</label>
                        <autocomplete id="_nip"
                                      ref="nip"
                                      :classes="{ wrapper: 'form-wrapper', input: 'form-control', list: 'data-list', item: 'data-list-item' }"
                                      :onShouldGetData="searchDebtorByNip"
                                      :onShouldRenderChild="renderAutocompleteItem"
                                      :onSelect="autocompleteItemSelected"
                                      :debounce="500"
                                      :min="2"
                                      :onInput="setNipValue"
                                      url="test"
                                      anchor="nip"
                        ></autocomplete>
                        <span v-if="errors && errors.customerData && errors.customerData.nip" class="help-block"
                              id="_nip_helpBlock">{{ errors.customerData.nip }}</span>
                    </div>
                    <div :class="{ 'form-group col-lg-6': true, 'has-error': (errors && errors.customerData && errors.customerData.regon) }">
                        <label for="_regon" class="control-label">REGON</label>
                        <autocomplete id="_regon"
                                      ref="regon"
                                      :classes="{ wrapper: 'form-wrapper', input: 'form-control', list: 'data-list', item: 'data-list-item' }"
                                      :onShouldGetData="searchDebtorByRegon"
                                      :onShouldRenderChild="renderAutocompleteItem"
                                      :onSelect="autocompleteItemSelected"
                                      :debounce="500"
                                      :min="2"
                                      :onInput="setRegonValue"
                                      url="test"
                                      anchor="regon"
                        ></autocomplete>
                        <span v-if="errors && errors.customerData && errors.customerData.regon" class="help-block"
                              id="_regon_helpBlock">{{ errors.customerData.regon }}</span>
                    </div>
                </div>
                <div class="row form-group">
                    <div :class="{ 'form-group col-lg-8': true, 'has-error': (errors && errors.customerData && errors.customerData.customerAddress && errors.customerData.customerAddress.street) }">
                        <label for="_address_street" class="control-label">Ulica</label>
                        <input type="text" id="_address_street" class="form-control"
                               v-model="item.customerData.customerAddress.street"/>
                        <span v-if="errors && errors.customerData && errors.customerData.customerAddress && errors.customerData.customerAddress.street"
                              class="help-block"
                              id="_address_street_helpBlock">{{ errors.customerData.customerAddress.street }}</span>
                    </div>
                    <div :class="{ 'form-group col-lg-4': true, 'has-error': (errors && errors.customerData && errors.customerData.customerAddress && errors.customerData.customerAddress.number) }">
                        <label for="_address_number" class="control-label">Numer domu</label>
                        <input type="text" id="_address_number" class="form-control"
                               v-model="item.customerData.customerAddress.number"/>
                        <span v-if="errors && errors.customerData && errors.customerData.customerAddress && errors.customerData.customerAddress.number"
                              class="help-block"
                              id="_address_number_helpBlock">{{ errors.customerData.customerAddress.number }}</span>
                    </div>
                </div>
                <div class="row form-group">
                    <div :class="{ 'form-group col-lg-4': true, 'has-error': (errors && errors.customerData && errors.customerData.customerAddress && errors.customerData.customerAddress.postalCode) }">
                        <label for="_address_postalCode" class="control-label">Kod pocztowy</label>
                        <input type="text" id="_address_postalCode" class="form-control"
                               v-model="item.customerData.customerAddress.postalCode"/>
                        <span v-if="errors && errors.customerData && errors.customerData.customerAddress && errors.customerData.customerAddress.postalCode"
                              class="help-block"
                              id="_address_postalCode_helpBlock">{{ errors.customerData.customerAddress.postalCode }}</span>
                    </div>
                    <div :class="{ 'form-group col-lg-8': true, 'has-error': (errors && errors.customerData && errors.customerData.customerAddress && errors.customerData.customerAddress.city) }">
                        <label for="_address_city" class="control-label">Miasto</label>
                        <input type="text" id="_address_city" class="form-control"
                               v-model="item.customerData.customerAddress.city"/>
                        <span v-if="errors && errors.customerData && errors.customerData.customerAddress && errors.customerData.customerAddress.city"
                              class="help-block"
                              id="_address_city_helpBlock">{{ errors.customerData.customerAddress.city }}</span>
                    </div>
                </div>
                <div :class="{ 'form-group': true, 'has-error': (errors && errors.customerData && errors.customerData.customerAddress && errors.customerData.customerAddress.country) }">
                    <label for="_address_country" class="control-label">Państwo</label>
                    <input type="text" id="_address_country" class="form-control"
                           v-model="item.customerData.customerAddress.country"/>
                    <span v-if="errors && errors.customerData && errors.customerData.customerAddress && errors.customerData.customerAddress.country"
                          class="help-block"
                          id="_address_city_helpBlock">{{ errors.customerData.customerAddress.country }}</span>
                </div>
            </div>
            <div class="col-lg-5 offset-lg-1">
                <h3>Dane faktury</h3>
                <div class="row form-group">
                    <div :class="{ 'form-group col-lg-6': true, 'has-error': (errors && errors.createDate) }">
                        <label for="_data" class="control-label">Data wystawienia</label>
                        <el-date-picker
                                v-model="item.createDate"
                                type="date"
                                placeholder="Data">
                        </el-date-picker>
                        <span v-if="errors && errors.createDate" class="help-block"
                              id="_data_helpBlock">{{ errors.createDate }}</span>
                    </div>
                    <div :class="{ 'form-group col-lg-6': true, 'has-error': (errors && errors.endDate) }">
                        <label for="_data" class="control-label">Data zakończenia</label>
                        <el-date-picker
                                v-model="item.endDate"
                                type="date"
                                placeholder="Data">
                        </el-date-picker>
                        <span v-if="errors && errors.endDate" class="help-block"
                              id="_data_helpBlock">{{ errors.endDate }}</span>
                    </div>
                </div>
                <div class="row form-group">
                    <div :class="{ 'form-group col-lg-6': true, 'has-error': (errors && errors.paymentDate) }">
                        <label for="_data" class="control-label">Termin zapłaty</label>
                        <el-date-picker
                                v-model="item.paymentDate"
                                type="date"
                                placeholder="Data">
                        </el-date-picker>
                        <span v-if="errors && errors.paymentDate" class="help-block"
                              id="_data_helpBlock">{{ errors.paymentDate }}</span>
                    </div>
                    <div :class="{ 'form-group col col-lg-6': true, 'has-error': (errors && errors.paid) }">
                        <b-form-checkbox id="checkbox1"
                                         v-model="item.paid">
                            Opłacona
                        </b-form-checkbox>
                        <span v-if="errors && errors.paid" class="help-block"
                              id="_currency_helpBlock">{{ errors.paid }}</span>
                    </div>
                </div>
                <div class="row form-group">
                    <div :class="{ 'form-group col-lg-6': true, 'has-error': (errors && errors.currency) }">
                        <label for="_currency" class="control-label">Waluta</label>
                        <dropdown-search x :elements="currencyTypes" emptyValue="Wybierz"
                                         valueField="@id" nameField="name" v-model="item.currency" @input="setCommentIfForeign"/>
                        <span v-if="errors && errors.currency" class="help-block"
                              id="_currency_helpBlock">{{ errors.currency }}</span>
                    </div>
                    <div :class="{ 'form-group col-lg-6': true, 'has-error': (errors && errors.paymentType) }">
                        <label for="_currency" class="control-label">Sposób zapłaty</label>
                        <dropdown-search x :elements="invoicePaymentType" emptyValue="Wybierz"
                                         valueField="@id" nameField="name" v-model="item.paymentType"/>
                        <span v-if="errors && errors.paymentType" class="help-block"
                              id="_currency_helpBlock">{{ errors.paymentType }}</span>
                    </div>
                </div>
                <div :class="{ 'form-group': true, 'has-error': (errors && errors.comments) }">
                    <label for="_comments" class="control-label">Uwagi</label>
                    <textarea type="text" id="_comments" class="form-control" v-model="item.comments"></textarea>
                    <span v-if="errors && errors.comments" class="help-block"
                          id="_comments_helpBlock">{{ errors.comments }}</span>
                </div>

            </div>
        </div>
        <h3 v-if="item.correction">Towary/usługi - było</h3>
        <div v-if="item.correction" class="table-responsive">
            <table class="table table-bordered table-hover">
                <thead>
                <tr>
                    <th>L.p.</th>
                    <th>Nazwa towaru/usługi</th>
                    <th class="th-narrow">Jm</th>
                    <th class="th-narrow">Ilość</th>
                    <th>Cena netto</th>
                    <th>Wartość netto</th>
                    <th>Stawka VAT</th>
                    <th>VAT</th>
                    <th>Wartość brutto</th>
                </tr>
                </thead>
                <tbody>
                <InvoiceItem v-for="item, index in item.correctedInvoiceItems" :values="item" :index="index"></InvoiceItem>
                </tbody>
            </table>
        </div>

        <h3>Towary/usługi<span v-if="item.correction"> - powinno być</span></h3>
        <div class="table-invoices">
            <div class="table-responsive">
                <table class="table table-bordered table-hover table-clickable">
                    <thead>
                    <tr>
                        <th>L.p.</th>
                        <th>Nazwa towaru/usługi</th>
                        <th class="th-narrow">Jm</th>
                        <th class="th-narrow">Ilość</th>
                        <th>Cena netto</th>
                        <th>Wartość netto</th>
                        <th>Stawka VAT</th>
                        <th>VAT</th>
                        <th>Wartość brutto</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <InvoiceItemForm v-for="(invoiceItem, index) in item.items" :values="item.items" :index="index" :errors="getViolationsForInvoiceItem(index)" :removeItem="removeItemRow"></InvoiceItemForm>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colspan="5" class="text-right td-no_link">Suma:</td>
                        <td class="td-no_link">{{netPrice}}</td>
                        <td></td>
                        <td class="td-no_link">{{tax}}</td>
                        <td class="td-no_link">{{grossPrice}}</td>
                        <td></td>
                      </tr>
                    </tfoot>
                </table>
            </div>
            <my-button text="Dodaj pozycję" icon="plus" type="button" variant="info" :action="addItemRow"/>
        </div>

        <router-link :to="{ name: 'InvoiceList' }" class="btn btn-primary"><span>Powrót</span>
            <svg-icon name="back"/>
        </router-link>
        <my-button text="Zapisz" icon="tick" type="submit"/>
    </form>
</template>

<script>
    import {mapGetters} from 'vuex'
    import http from './../../utils/http'
    import InvoiceItemForm from './InvoiceItemForm.vue'
    import InvoiceItem from './InvoiceItem.vue';

    export default {
    props: {
      handleSubmit: {
        type: Function,
        required: true,
      },
      values: {
        type: Object,
        required: true
      },
      errors: {
        type: Object
      },
      initialValues: {
        type: Object
      }
    },
    components: {
      InvoiceItemForm,
      InvoiceItem
    },
    computed: {
      item: function () {
        return this.initialValues ? this.initialValues : this.values
      },
      tax: function () {
        let price = 0;
        for(let i = 0; i < this.item.items.length; i++){
          const value =  this.item.items[i];
          const tmp = parseFloat(parseFloat(value.amount) * parseFloat(value.price) * (parseFloat(value.tax)/100))
          if(tmp) {
            price += tmp
          }
        }
        if(this.item.correction){
          for(let i = 0; i < this.item.correctedInvoiceItems.length; i++){
            const value =  this.item.correctedInvoiceItems[i];
            const tmp = parseFloat(parseFloat(value.amount) * parseFloat(value.price) * (parseFloat(value.tax)/100))
            if(tmp) {
              price -= tmp
            }
          }
        }

        price = price.toFixed(2);
        return price == 'NaN' ? '' : price;
      },
      netPrice: function () {
        let price = 0;
        for(let i = 0; i < this.item.items.length; i++){
          const value =  this.item.items[i];
          const tmp =  parseFloat(parseFloat(value.amount) * parseFloat(value.price))
          if(tmp) {
            price += tmp
          }
        }
        if(this.item.correction){
          for(let i = 0; i < this.item.correctedInvoiceItems.length; i++){
            const value =  this.item.correctedInvoiceItems[i];
            const tmp =  parseFloat(parseFloat(value.amount) * parseFloat(value.price))
            if(tmp) {
              price -= tmp
            }
          }
        }
        price = price.toFixed(2);
        return price == 'NaN' ? '' : price;
      },
      grossPrice: function () {
        let price = 0;
        for(let i = 0; i < this.item.items.length; i++){
          const value =  this.item.items[i];
          const tmp = parseFloat(parseFloat(value.amount) * parseFloat(value.price) + parseFloat(parseFloat(value.amount) * parseFloat(value.price) * (parseFloat(value.tax)/100)));
          if(tmp) {
            price += tmp
          }
        }
        if(this.item.correction){
          for(let i = 0; i < this.item.correctedInvoiceItems.length; i++){
            const value =  this.item.correctedInvoiceItems[i];
            const tmp = parseFloat(parseFloat(value.amount) * parseFloat(value.price) + parseFloat(parseFloat(value.amount) * parseFloat(value.price) * (parseFloat(value.tax)/100)));
            if(tmp) {
              price -= tmp
            }
          }
        }
        price = price.toFixed(2);
        return price == 'NaN' ? '' : price;
      },
      ...mapGetters({
        currencyTypes: 'config/config/currencyTypes',
        invoicePaymentType: 'config/config/invoicePaymentType'
      })
    },
    methods: {
      getViolationsForInvoiceItem: function(index){
        if(this.errors != undefined && this.errors['items['+index+']']){
          return this.errors['items['+index+']'];
        }

        return {}
      },
      removeItemRow: function (index) {
        this.item.items.splice(index, 1);
      },
      addItemRow: function () {
        this.item.items.push({amount: '', price: '', tax: 23, unit: 'usł.'})
      },
      searchDebtorByName: function (value) {
        return http.fetch('/invoice_customers?name=' + value)
          .then(response => response.json())
          .then(data => {
            return data['hydra:member']
          })
      },
      searchDebtorByNip: function (value) {
        return http.fetch('/invoice_customers?nip=' + value)
          .then(response => response.json())
          .then(data => {
            return data['hydra:member']
          })
      }
      ,
      searchDebtorByRegon: function (value) {
        return http.fetch('/invoice_customers?regon=' + value)
          .then(response => response.json())
          .then(data => {
            return data['hydra:member']
          })
      },
      setRegonValue (value) {
        this.item.customerData.regon = value.replace(/\s\s+/g, ' ').trim()
      },
      setNameValue (value) {
        this.item.customerData.name = value.replace(/\s\s+/g, ' ').trim()
      },
      setNipValue (value) {
        this.item.customerData.nip = value.replace(/\s\s+/g, ' ').trim()
      },
      sendForm () {
        this.handleSubmit(this.item)
      },
      setValueToAutocmplitedField () {
        if(this.$refs.name){
          this.$refs.name.setValue(this.item.customerData.name)
          this.$refs.nip.setValue(this.item.customerData.nip)
          this.$refs.regon.setValue(this.item.customerData.regon)
        }
      },
      autocompleteItemSelected: function (data) {
        this.item.customerData.name = data.name
        this.item.customerData.nip = data.nip
        this.item.customerData.regon = data.regon
        this.item.customerData.customerAddress.city = data.address.city
        this.item.customerData.customerAddress.number = data.address.number
        this.item.customerData.customerAddress.postalCode = data.address.postalCode
        this.item.customerData.customerAddress.street = data.address.street
        this.item.customerData.customerAddress.country = data.address.country

        this.setValueToAutocmplitedField()
      },
      renderAutocompleteItem: function (data) {
        let response = data.name
        if (data.nip != undefined && data.nip != '') {
          response += ` NIP ${data.nip}`
        }
        if (data.regon != undefined && data.regon != '') {
          response += ` REGON ${data.regon}`
        }
        return response
      },
      setCommentIfForeign: function(){
        if(!this.item.comments || this.item.comments.length === 0){
          var currency = this.currencyTypes.find(item => item['@id'] == this.item.currency)
          if(currency && currency.foreign){
            var taxValue = '....';
            if(this.tax !== '0.00'){
              taxValue = this.tax;
            }
            this.item.comments ='VAT przeliczono po kursie średnim NBP z dnia  .......( Tabela nr ..........) ' + taxValue +' ' + currency.name +' x ..... = .....';
          }
        }

      }
    },
    mounted () {
      this.setValueToAutocmplitedField()
      this.setCommentIfForeign();
    },
  }
</script>



// WEBPACK FOOTER //
// Form.vue?00fe307c